import React from "react";
import { useParams } from "react-router-dom";
import JobPageContainer from "../../containers/customer_portal/Job";

const UpdateJobPage = () => {
  const { jobId } = useParams();
  return <JobPageContainer job_id={jobId} mode="update" />;
};

export default UpdateJobPage;